import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import { useEffect, useState } from 'react';
import { SVG } from '../../../constants/assetLists';
import { useOnBoardingContext } from '../../../context/onBoarding/OnBoardingContextProvider';

function formatSavedTime(savedAt: Date, now: Date) {
  const elapsedMinutes = Math.floor(
    (now.getTime() - savedAt.getTime()) / 60000,
  );

  if (elapsedMinutes < 1) return 'נשמר עכשיו';
  if (elapsedMinutes === 1) return 'נשמר לפני דקה';
  if (elapsedMinutes < 5) return `נשמר לפני ${elapsedMinutes} דקות`;

  return `נשמר בשעה ${savedAt.toLocaleTimeString('he-IL', {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
}

function DraftSaveStatus() {
  const { currentStep, draftLastSavedAt, draftSaveStatus } =
    useOnBoardingContext();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (draftSaveStatus === 'idle') return;

    const interval = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(interval);
  }, [draftSaveStatus]);

  if (currentStep !== 2 || draftSaveStatus === 'idle') return null;

  const lastSavedLabel = draftLastSavedAt
    ? formatSavedTime(draftLastSavedAt, now)
    : null;

  if (draftSaveStatus === 'saving') {
    return (
      <div className="flex items-center gap-2 text-white" aria-live="polite">
        <img
          src={SVG.loadingIcon}
          alt=""
          className="w-[22px] h-[22px] object-contain animate-spin"
        />
        <span className="text-base">שומר...</span>
      </div>
    );
  }

  if (draftSaveStatus === 'failed') {
    return (
      <div
        className="flex items-center gap-2 text-white"
        role="status"
        aria-live="polite"
      >
        <img
          src={SVG.warningIcon}
          alt=""
          className="w-[27px] h-[27px] object-contain"
        />
        <span className="text-base">
          השמירה נכשלה
          {lastSavedLabel ? ` (${lastSavedLabel})` : ''}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-white" aria-live="polite">
      <CloudDoneOutlinedIcon sx={{ fontSize: 27 }} />

      <span className="text-base">{lastSavedLabel}</span>
    </div>
  );
}

export default DraftSaveStatus;
